import cigarette_icon from 'src/assets/cigarette_icon.svg'
import coffee_icon from 'src/assets/coffee_icon.svg'
import gaming_controller_icon from 'src/assets/gaming_controller_icon.svg'
import internet_addiction_icon from 'src/assets/internet_addiction_icon.svg'
import CoolMultiCardCarousel from '../common/CoolMultiCardCarousel/CoolMultiCardCarousel'
import {
  AddictionTypesCardHeadingImage,
  BackgroundContainerForPublicPagesVarOne,
} from './styledComponents'

export default function AddictionTypesCard() {
  const cardsData = [
    {
      headingIcon: <AddictionTypesCardHeadingImage src={internet_addiction_icon} alt='internetIcon' />,
      subHeading: 'Internet',
      description:
        'Constantly glued to your devices? Internet addiction can significantly impact your daily life, relationships, and mental well-being.',
    },
    {
      headingIcon: <AddictionTypesCardHeadingImage src={gaming_controller_icon} alt='gamingIcon'/>,
      subHeading: 'Gaming',
      description:
        'Is gaming taking over your life? Gaming addiction can lead to social isolation, sleep disturbances, and a decline in academic or work performance.',
    },
    {
      headingIcon: <AddictionTypesCardHeadingImage src={cigarette_icon} alt='cigaretteIcon' />,
      subHeading: 'Smoking',
      description:
        'Want to quit smoking for good? Cigarette addiction is tough, but quitting is one of the best things you can do for your health.',
    },
    {
      headingIcon: <AddictionTypesCardHeadingImage src={coffee_icon} alt='coffeeIcon'/>,
      subHeading: 'Caffeine',
      description:
        'Do you rely on coffee to get through the day? Too much caffeine can mess with your sleep and make you anxious.',
    },
  ]

  return (
    <CoolMultiCardCarousel
      mainContainerStyles={{}}
      carouselHeading="Behavioral De-Addiction"
      carouselSubHeading="Types of Addictions"
      cards={cardsData}
      MainContainerStyledComponent={BackgroundContainerForPublicPagesVarOne}
    />
  )

  // return (
  //   <ShadeBackgroundForPublicPagesVariantOne>
  //     <div
  //       style={{
  //         fontSize: '1.5rem',
  //         fontWeight: '500',
  //         width: '100%',
  //         textAlign: 'center',
  //         padding: '24px 24px 0',
  //       }}
  //     >
  //       Work on your Behavioral Addiction Plan
  //     </div>
  //     <FourCardsOptionsVariantOne
  //       dataLandscapeCards={ADDICTION_LANDINGPAGE_FOUR_CARD_DESIGN_LANDSCAPE_DATA}
  //       dataPortraitCards={ADDICTION_LANDINGPAGE_FOUR_CARD_DESIGN_PORTRAIT_DATA}
  //       hoverEffects={false}
  //     />
  //   </ShadeBackgroundForPublicPagesVariantOne>
  // )
}
